module.exports = __webpack_public_path__ + "img/purchase-order.e6fc04ca.svg";